/**
 * EventVendorStatusService
 * Service for managing event vendor statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for event vendor status CRUD operations
 */
export class EventVendorStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventVendorStatusService.DEFAULT_SERVICE_PATH,
            basePath: EventVendorStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EventVendorStatusService.DEFAULT_SERVICE_PATH = 'events';
EventVendorStatusService.BASE_PATH = 'api/event-vendor-statuses';
//# sourceMappingURL=EventVendorStatusService.js.map